import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconMarketUpgrade = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={34}
    fill="none"
    viewBox="0 0 42 34"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-market-upgrade_svg__a)">
      <path
        fill="url(#icon-market-upgrade_svg__b)"
        d="M17.836 22.75c1.055 0 1.836.86 1.836 1.875 0 1.055-.86 1.875-1.836 1.875-1.016 0-1.836-.82-1.836-1.875 0-1.016.781-1.875 1.836-1.875Zm11.25 0c1.055 0 1.875.86 1.875 1.875 0 1.055-.898 1.875-1.875 1.875-1.016 0-1.836-.82-1.836-1.875 0-1.016.781-1.875 1.836-1.875Zm4.14-14.492c.235.312.313.742.196 1.133l-2.149 7.46a1.208 1.208 0 0 1-1.171.899H17.64l.351 1.875h12.07c.508 0 .938.43.938.977 0 .507-.43.898-.938.898H17.25c-.469 0-.86-.313-.977-.742L13.93 8.375h-2.032c-.507 0-.898-.469-.898-.938 0-.507.39-.937.898-.937h2.852c.43 0 .82.352.898.781l.079.469H32.21c.43 0 .781.195 1.016.508ZM9.439 12.125c-.547 0-.938-.39-.938-.938 0-.507.39-.937.938-.937h3.124a.95.95 0 0 1 .938.938c0 .546-.43.937-.938.937H9.438Zm0 3.125c-.547 0-.938-.39-.938-.938 0-.507.39-.937.938-.937h3.75a.95.95 0 0 1 .937.938c0 .546-.43.937-.938.937h-3.75Zm4.374 1.25a.95.95 0 0 1 .938.938c0 .546-.43.937-.938.937H9.439c-.547 0-.938-.39-.938-.938 0-.507.39-.937.938-.937h4.374Z"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-market-upgrade_svg__b"
        x1={31}
        x2={12.025}
        y1={7}
        y2={26.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
      <filter
        id="icon-market-upgrade_svg__a"
        width={41.039}
        height={36}
        x={0.5}
        y={0.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6025_5393"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_6025_5393"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_6025_5393"
          result="effect2_dropShadow_6025_5393"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_6025_5393"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconMarketUpgrade;
